import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import { AppContextProvider } from './AppContextProvider';
import NotificationProvider from './components/notifications/NotificationProvider';
import ConnectedIntlProvider from './i18n/ConnectedIntlProvider';
import { store } from './redux/store';
import { initSentry } from './sentrySetup';
import * as serviceWorker from './serviceWorker';
import './index.css';
import '@/../telemetry.config';

declare global {
  // Workaround for vite federation runtime placeholder in host dev mode.
  var __rf_placeholder__shareScope: Record<string, unknown> | undefined;
}

globalThis.__rf_placeholder__shareScope ??= {};

initSentry();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container not found');
}
const root = createRoot(container);

root.render(
  <AppContextProvider>
    <Provider store={store}>
      <ConnectedIntlProvider>
        <NotificationProvider>
          <App />
        </NotificationProvider>
      </ConnectedIntlProvider>
    </Provider>
  </AppContextProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
